<template>
  <div class="product-benefits">
    <input type="hidden" name="benefits" v-model="benefitsImploded" />

    <input type="file"
           style="display: none"
           name="newImage"
           accept="image/*"
           id="newImageForBenefit"
           v-on:change="addFile($event)"
    />

    <table class="table table-sm">
      <thead>
        <tr>
          <th>#</th>
          <th style="width: 150px" class="text-center">Image</th>
          <th style="width: 300px">Title</th>
          <th style="width: 300px">Description</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(ben, index) in benefits" :key="index">
          <td>
            {{ index + 1 }}
          </td>
          <td class="text-center">
            <img :src="ben.image"
                 style="width: 100px; margin-bottom: 5px"
                 alt=""
            />

            <label class="button button-primary-outline btn-sm d-block" for="newImageForBenefit" @click="startUpload(index)">
              <i class="fas fa-circle-plus"></i>
              Upload image
            </label>
          </td>
          <td>
            <input type="text" class="form-control" v-model="ben.name" placeholder="Benefit title" />
          </td>
          <td>
            <textarea class="form-control"
                      rows="5"
                      placeholder="Benefit description"
                      v-model="ben.description"
            ></textarea>
          </td>
          <td>
            <div class="actions">
              <button class="btn btn-sm edit action"
                      type="button"
                      @click="move(index, -1)">
                <i class="fas fa-chevron-up"></i>
              </button>
              <button class="btn btn-sm btn-danger action"
                      type="button"
                      @click="remove(index)">
                <i class="far fa-trash-alt"></i>
              </button>
              <button class="btn btn-sm edit action"
                      type="button"
                      @click="move(index, 1)">
                <i class="fas fa-chevron-down"></i>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td colspan="5">
            <button class="btn btn-success"
                    type="button"
                    @click="add">
              Add benefit
            </button>
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
export default {
  name: "ProductBenefits",
  props: ['product'],
  data(){
    return {
      benefits: [],
      benefitsImploded: '',
      imageIndex: -1
    }
  },
  mounted() {
    setTimeout(() => {
      let benefits = JSON.parse(JSON.stringify(this.product.benefits))

      for (let item of benefits) {
        if(typeof item === 'object' && !Array.isArray(item) && item !== null){
          this.benefits.push(item)
        }
      }
    }, 50)
  },
  watch: {
    benefits: {
      deep: true,
      handler(){
        this.benefitsImploded = JSON.stringify(this.benefits)
      }
    }
  },
  methods: {
    startUpload(index) {
      this.imageIndex = index
    },
    add(){
      this.benefits.push({
        name: "",
        description: "",
        image: ''
      })
    },
    move(index, step){
      let newIndex = index + step

      if(newIndex < 0 || newIndex === this.benefits.length){
        return
      }

      let oldVal = this.benefits[newIndex]
      this.benefits[newIndex] = this.benefits[index]
      this.benefits[index] = oldVal

      this.benefitsImploded = JSON.stringify(this.benefits)

      this.$forceUpdate()
    },
    remove(index){
      $.confirm({
        title: '',
        content: `<div style="font-size: 1.3em">Are you sure want to delete this benefit?</div>`,
        buttons: {
          confirm: {
            text: 'Ok',
            btnClass: 'btn btn-success',
            keys: ['enter'],
            action: () => {
              this.benefits.splice(index, 1)
              this.$forceUpdate()
            }
          },
          cancel: {
            text: 'Cancel',
            btnClass: 'btn btn-danger',
            keys: ['esc', 'escape'],
          },
        }
      })
    },
    addFile(event) {
      let fileReader = new FileReader();

      let file = event.target.files[0];

      if (!file) {
        return
      }

      fileReader.addEventListener("load", () => {
        // convert image file to base64 string
        this.benefits[this.imageIndex].image = fileReader.result
        this.imageIndex = -1
      }, false);

      fileReader.readAsDataURL(file);

      $('#newImageForBenefit')[0].file = null
      $('#newImageForBenefit').val(null)
    },
  }
}
</script>

<style scoped>

</style>
